import { Alert, Button,  Snackbar, TextField } from '@mui/material';
import { doc, getDoc, onSnapshot, updateDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from './firebaseConfig';
import { Link, useNavigate, useParams } from 'react-router-dom';

function GuestName() {
    const [name, setName] = useState('');
    const { documentId } = useParams();
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [isTriviaOn, setIsTriviaOn] = useState(false);
    const navigate = useNavigate();

    
  useEffect(() => {

    const unsub = onSnapshot(doc(db, "isTriviaOn", "s5y7fVw6BM5iOZs75VdM"), (doc) => {

      const data = doc.data();

      setIsTriviaOn(data.isOn)

    });

    return () => unsub();

  }, []);


    useEffect(() => {
        const fetchGuestData = async () => {
            try {
                const guestDocRef = doc(db, 'guest', documentId);
                const guestDocSnap = await getDoc(guestDocRef);

                if (guestDocSnap.exists()) {
                    const guestData = guestDocSnap.data();
                    setName(guestData.name);
                } else {
                    //setError('Guest not found');
                }
            } catch (error) {
                console.error('Error fetching guest data:', error);
                //setError('Failed to fetch guest data');
            } finally {
                //setLoading(false);
            }
        };

        fetchGuestData();
    }, [documentId]);

    const handleSave = async (event) => {
        event.preventDefault(); // Prevents the default form submission behavior

        const updatedGuest = {
            name: name,
        };

        const guestDocRef = doc(db, 'guest', documentId);
        await updateDoc(guestDocRef, updatedGuest);

        setShowSnackbar(true);
    };

    const handleSnackbarClose = () => {
        setShowSnackbar(false);
    };

    return (
        <div>
            <label>My Name/Our Names:</label><br></br>
            <TextField
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
            />
            <br></br><br></br>
            <Button variant="contained" onClick={handleSave}>
                Save
            </Button>

            <Snackbar
                open={showSnackbar}
                autoHideDuration={10000}
                onClose={handleSnackbarClose}
                message="Save successful!"
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                    Save successful!
                </Alert>
            </Snackbar>
            <br></br><br></br>
            {
            isTriviaOn &&           <Button variant="contained" onClick={()=>{navigate(`/guest-questions/${documentId}`)}}>
            Trivia Time
          </Button>

          }<br></br>
            <br></br>
            <span>You can write a few lines of advice, share a favorite memory, or express your admiration for Punya's accomplishments. Click <Link to={`/guest-access/${documentId}`}>Here</Link>.</span>

            
        </div>
    )
}

export default GuestName
